import React, { useState, FunctionComponent } from "react";
import styles from "./LocationSelector.module.scss";
import LocationSelectorProps from "./LocationSelectorProps.interface";

import getCurrentLocation from "./helpers/getCurrentLocation";

import { useLocation } from "react-router";
import Anchor from "components/Anchor/Anchor";
import IconViewer from "components/IconViewer/IconViewer";
import useClickOutside from "layout/hooks/useClickOutside";

const LocationSelector: FunctionComponent<LocationSelectorProps> = (props) => {
    const location = useLocation();

    const [isToggled, setIsToggled] = useState(false);
    const wrapperElementRef = useClickOutside(() => setIsToggled(false));
    const currentLocation = getCurrentLocation(props.locations, location.pathname);

    return (
        <div className={styles.wrapper} ref={wrapperElementRef}>
            {/* Button */}
            <button className={styles.button} onClick={() => setIsToggled(!isToggled)}>
                <IconViewer className={styles.button_icon} name="location" />
                {currentLocation?.content.label}
                <IconViewer className={styles.button_chevron} name="chevron-down" />
            </button>

            {/* Dropdown */}
            {isToggled === true ? (
                <div className={styles.list}>
                    {props.locations?.map((location: any, index: number) => (
                        <span key={index} onClick={() => setIsToggled(!isToggled)}>
                            {/* TODO: Use Redux to show dropdown */}
                            <Anchor className={styles.item} to={location.content?.link}>
                                {location.content?.label}
                            </Anchor>
                        </span>
                    ))}

                    <button className={styles.current_item} onClick={() => setIsToggled(false)}>
                        <IconViewer className={styles.button_icon} name="location" />
                        {currentLocation?.content.label}
                        <IconViewer className={styles.button_chevron} name="chevron-up" />
                    </button>
                </div>
            ) : null}
        </div>
    );
};

export default LocationSelector;
